import React from 'react';
import { Link } from 'react-router-dom';
import { faqData } from '../mock/data';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  return (
    <section id="faq" className="py-20 bg-white">
      <div className="container mx-auto px-4 max-w-4xl">
        {/* Section Title */}
        <div className="text-center mb-16 animate-in fade-in slide-in-from-bottom duration-700">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            <span className="text-[#52a675]">FAQs</span>
          </h2>
          <p className="text-lg text-gray-600">
            Vous avez des questions concernant CarMaintenance ? Nous avons rassemblé ici les réponses aux questions les plus fréquentes
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="animate-in fade-in slide-in-from-bottom duration-700 delay-150">
          <Accordion type="single" collapsible className="space-y-4">
            {faqData.map((faq, index) => (
              <AccordionItem
                key={faq.id}
                value={faq.id}
                className="border border-gray-200 rounded-lg px-6 hover:border-[#52a675] transition-colors"
              >
                <AccordionTrigger className="text-left font-semibold text-gray-900 hover:text-[#52a675] py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 pb-5 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* Contact CTA */}
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">Vous avez d'autres questions ?</p>
          <Link
            to="/contact"
            className="text-[#52a675] font-semibold hover:underline"
            data-testid="home-faq-contact-btn"
          >
            Contactez-nous
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
